
import { useEffect, useRef, useCallback } from 'react';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

function sendGA4Event(eventName: string) {
  const key = `ga4_sent_${eventName}`;
  if (sessionStorage.getItem(key)) return;
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName);
    sessionStorage.setItem(key, '1');
  }
}

export function useGA4ViewEvent(eventName: string) {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            sendGA4Event(eventName);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.3 },
    );

    observer.observe(el);

    return () => {
      observer.unobserve(el);
    };
  }, [eventName]);

  return ref;
}

export function useGA4ClickEvent(eventName: string) {
  return useCallback(() => {
    sendGA4Event(eventName);
  }, [eventName]);
}

export { sendGA4Event };
